import { AxiosError } from 'axios';
import { useCustomMutation } from '../utils/useCustomMutation';
import axiosClient from '../axiosClient';
import { POST_REVIEW_AUDIT_REPORT } from '../../constants/apiUrls';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (res: any) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
  reportId: string;
  remarks?: string;
}

export const usePostReviewAuditReport = ({ onSuccess, onError, reportId, remarks }: Input) => {
  const PostAuditReportListing = async () => {
    const res = await axiosClient.post(POST_REVIEW_AUDIT_REPORT(reportId), {
      remarks,
    });
    return res.data;
  };
  return useCustomMutation(PostAuditReportListing, {
    onSuccess,
    onError,
  });
};
